import React, { useEffect, useState } from 'react'

import Menu from '../../components/UI/UIMenu'
import Modal from '../../components/UI/UIModal'
import UITextInput from '../../components/UI/UITextInput'
import UISubHeaderComponent from '../../components/UI/UISubHeaderComponent'
import { Icon } from '../../components/Icon'

import { ManageCategoriesHeader, TrainingHeader } from '../../data/index'
// import Pagination from '../../components/UI/Pagination'
import UIButton from '../../components/UI/UIButton'
// import UIDocumentPicker from '../../components/UI/UIDocumentPicker'

import '../../App.css'
import { useQuery } from 'react-query'
import { getCategories } from './apiCall'

import Loading from '../../components/UI/Loading'

import {} from // createTraningCategory,
// deleteCategory,
// updateTraningRecordCategory,
'../../api/admin/trainingRecord'
import { safeguardingCategories } from '../../utils/types'
import { toast } from 'react-toastify'
import UISwitch from '../../components/UI/UISwitch'
import {
  createSafeguardingCategory,
  deleteCategory,
  updateSafeguardingRecordCategory,
} from '../../api/admin/Safeguarding'

interface ManageCategoriesHeaderInterface {
  Title: string
  'Created At': string
  'Updated At': string
  'Created By': string
  'Updated By': string
  'Total Records': string
  Status: string
}

const SafeguardingCategories = () => {
  const [categoryName, setCategoryName] = useState('')
  const [url, setUrl] = useState('')
  const [categoryId, setCategoryId] = useState('')
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isEditTRCategory, setIsEditTRCategory] = useState<boolean>(false)
  const [riskAssesmentSwitchValue, setRiskAssesmentSwitchValue] =
    useState<boolean>(false)
  const [issueDateSwitchValue, setIssueDateSwitchValue] =
    useState<boolean>(false)
  const [expiryDateSwitchValue, setExpiryDateSwitchValue] =
    useState<boolean>(false)

  const [isOpenDeleteTRModalCategory, setIsOpenDeleteTRModalCategory] =
    useState<boolean>(false)

  const [isView, setIsView] = useState<string>('Manage Categories')

  const [sortOrderManageCategories, setSortOrderManageCategories] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortByManageCategories, setSortByManageCategories] =
    useState<string>('createdAt')
  const [sortOrderValueManageCategories, setSortOrderValueManageCategories] =
    useState<string>('asc')

  const categories = useQuery('safeguardingCategories', () =>
    getCategories(
      // currentPage2,
      sortByManageCategories,
      sortOrderValueManageCategories
    )
  )

  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(Number(categories.data?.count) || 100).fill(false)
  )

  const handleSortManageCategories = (key: string) => {
    const newSortOrder = { ...sortOrderManageCategories }
    // console.log(' newSortOrder[key]', key)
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      // console.log(' newSortOrder[testjdjsn]', newSortOrder[key])
      newSortOrder[key] = 'desc'
      setSortByManageCategories(key)
      setSortOrderValueManageCategories('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortByManageCategories(key)
      setSortOrderValueManageCategories('asc')
    }
    setSortOrderManageCategories(newSortOrder)
  }

  useEffect(() => {
    categories.refetch() // Refetch Categories when sortBy or sortOrderValue changes
  }, [sortByManageCategories, sortOrderValueManageCategories])

  // const handlePageChange = (pageNumber: number): void => {
  //   setCurrentPage(pageNumber)
  // }
  // const handlePageChange2 = (pageNumber: number): void => {
  //   setCurrentPage2(pageNumber)
  // }

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }
  const handleRiskSwitchChange = (value: boolean) => {
    setRiskAssesmentSwitchValue(value)
  }
  const handleIssueDateSwitchChange = (value: boolean) => {
    setIssueDateSwitchValue(value)
  }
  const handleExpiryDateSwitchChange = (value: boolean) => {
    setExpiryDateSwitchValue(value)
  }

  const handleOpenModal = () => {
    setIsOpen(true)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
    setIsEditTRCategory(false)
  }

  const createNewCategory = async (): Promise<void> => {
    try {
      const response = (await createSafeguardingCategory({
        riskAssessment: riskAssesmentSwitchValue,
        expiryDate: expiryDateSwitchValue,
        issueDate: issueDateSwitchValue,
        title: categoryName,
        referenceUrl: url,
      })) as {
        status?: string
        data: safeguardingCategories
      }
      if (response?.status == 'successful') {
        categories.refetch()
        setIsEditTRCategory(false)
        setRiskAssesmentSwitchValue(false)
        setIssueDateSwitchValue(false)
        setExpiryDateSwitchValue(false)
        setCategoryName('')
        handleCloseModal()
        toast.success('Category Created.', {
          position: 'top-right',
        })
        // setIsLoading(false)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
        // setIsLoading(false)
      }
    } catch (error) {
      console.error('Error creating category:', error)
      toast.warning(`${'please insert correct url'}`, {
        position: 'top-right',
      })
    }
  }

  const editCategory = async (): Promise<void> => {
    const response = (await updateSafeguardingRecordCategory(
      {
        riskAssessment: riskAssesmentSwitchValue,
        expiryDate: expiryDateSwitchValue,
        issueDate: issueDateSwitchValue,
        title: categoryName,
        referenceUrl: url,
      },
      categoryId
    )) as {
      status?: string
      data: safeguardingCategories
    }
    if (response?.status == 'successful') {
      categories.refetch()
      setIsEditTRCategory(false)
      setCategoryName('')
      setRiskAssesmentSwitchValue(false)
      setIssueDateSwitchValue(false)
      setExpiryDateSwitchValue(false)
      // setIsOpen(!isOpen)
      handleCloseModal()
      toast.success('Category Updated.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }
  const removeCategory = async (): Promise<void> => {
    try {
      const response = (await deleteCategory({ id: categoryId })) as {
        status?: string
        data: safeguardingCategories
      }
      if (response?.status == 'successful') {
        categories.refetch()
        setIsOpenDeleteTRModalCategory(false)
        setRiskAssesmentSwitchValue(false)
        setIssueDateSwitchValue(false)
        setExpiryDateSwitchValue(false)
        // setIsOpen(!isOpen)
        toast.success('Deleted.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }

  // useEffect(() => {
  //   categories.refetch()
  // }, [currentPage2])

  // useEffect(() => {
  //   traningRecords.refetch()
  // }, [currentPage])

  return (
    <div
      className={'flex flex-col gap-6 w-full bg-white  h-full rounded-3xl p-8 '}
    >
      {isView == 'Manage Categories' && (
        <div
        // style={{
        //   height: 'calc(100vh - 100px)',
        //   overflow: 'hidden',
        //   scrollbarWidth: 'none',
        // }}
        >
          <UISubHeaderComponent
            mainPage="Safeguarding Categories"
            subPage=""
            copy="Here you can view and manage your Safeguarding categories or add new ones."
            onCreate={handleOpenModal}
            onBack={() => setIsView('Manage Categories')}
            // onPublish={handleOpenModal}
            isViewMode={false}
            isButton={true}
            buttonIcon="IconPlus"
            buttonLable="Create Safeguarding Category"
            isButtonOnClick={handleOpenModal}
          />
          {/* content container */}
          <div className="relative h-full overflow-y-auto">
            <div className=" max-h-full h-full overflow-y-auto">
              {categories.isLoading && (
                <div className="flex-col  w-[100%] p-[10px]">
                  <Loading size="large" />
                </div>
              )}
              {!categories.isLoading && (
                <div className=" rounded-[16px] bg-gray1">
                  <table className="min-w-full table-auto divide-y divide-white rounded-[16px] ">
                    <thead className="sticky top-0 z-10 mb-4 rounded-[16px] ">
                      <tr className="bg-gray2 rounded-lg h-10 mb-18">
                        {ManageCategoriesHeader?.map(
                          (item: string, index: number) => {
                            return (
                              <th
                                key={index}
                                className={`px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''} ${index === TrainingHeader.length - 1 ? 'border-none' : 'border-r border-white'}`}
                              >
                                <div className="flex items-center">
                                  <p className="text-text1 font-semibold text-sm flex-1">
                                    {item}
                                  </p>
                                  <div
                                    className="cursor-pointer"
                                    onClick={() => {
                                      let sortBy = ''
                                      switch (
                                        item as keyof ManageCategoriesHeaderInterface
                                      ) {
                                        case 'Title':
                                          sortBy = 'title'
                                          break
                                        case 'Created At':
                                          sortBy = 'createdAt'
                                          break
                                        case 'Updated At':
                                          sortBy = 'updatedAt'
                                          break
                                        case 'Created By':
                                          sortBy = 'createdByName'
                                          break
                                        case 'Updated By':
                                          sortBy = 'updatedByName'
                                          break
                                        case 'Status':
                                          sortBy = 'status'
                                          break
                                        case 'Total Records':
                                          sortBy = 'createdAt'
                                          break
                                        default:
                                          break
                                      }
                                      // console.log('valueeyyyyyyyyy--->', sortBy)
                                      handleSortManageCategories(sortBy)
                                    }}
                                  >
                                    <Icon
                                      name={'IconChevronDown'}
                                      width={16}
                                      height={16}
                                      strokeWidth={1}
                                      stroke={'#67A5B9'}
                                    />
                                  </div>
                                </div>
                              </th>
                            )
                          }
                        )}
                        <th className="w-[56px] rounded-r-lg"></th>{' '}
                      </tr>
                    </thead>
                    <tbody className=" pt-72 divide-y divide-white">
                      {categories?.data?.data?.map((item, index) => (
                        <>
                          <tr className="bg-gray1">
                            {/* Example row */}
                            <td className="px-4 font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                              <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                                {item.title}
                              </p>
                            </td>

                            <td className="px-4 font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                              <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                                {item.createdAt?.substring(0, 16)}
                              </p>
                            </td>

                            <td className="px-4 font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                              <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                                {item.createdByName}
                              </p>
                            </td>
                            <td className="px-4 font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                              <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                                {item.updatedByName}
                              </p>
                            </td>
                            <td className="px-4 font-medium text-textError text-[12px] h-[48px] py-2 border-b border-white">
                              <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                                {item.updatedByName == null
                                  ? ''
                                  : item.updatedAt?.substring(0, 16)}
                              </p>
                            </td>

                            {/* <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <p className="flex-1 text-sm text-text1 leading-6 font-semibold"></p>
                            </td> */}

                            <td className="px-4 items-center justify-center flex relative  h-[48px] py-2 border-b border-white">
                              <Menu
                                isOpen={isOpenMenu[index]}
                                items={[
                                  {
                                    label: 'Edit',
                                    onClick: () => {
                                      setIsEditTRCategory(true)
                                      setCategoryId(item.id)
                                      setCategoryName(item.title)
                                      setUrl(item.referenceUrl)
                                      setRiskAssesmentSwitchValue(
                                        item.riskAssessment
                                      )
                                      setIssueDateSwitchValue(item.issueDate)
                                      setExpiryDateSwitchValue(item.expiryDate)

                                      setIsOpen(true)
                                    },
                                    icon: 'IconEdit',
                                    iconColor: '#02698C',
                                  },
                                  {
                                    label: 'Remove',
                                    onClick: () => {
                                      setCategoryId(item.id)
                                      setIsOpenDeleteTRModalCategory(true)
                                    },
                                    icon: 'IconTrash',
                                    iconColor: '#FF6666',
                                    textColor: 'text-textError',
                                  },
                                ]}
                                type={'table'}
                                setIsOpenMenu={setIsOpenMenu}
                                isOpenMenus={isOpenMenu}
                              >
                                <div
                                  onClick={() => {
                                    handleToggleMenu(index)
                                    console.log(item.id)
                                    // setId(item.id)
                                  }}
                                  className="cursor-pointer"
                                >
                                  <Icon
                                    name={'IconDotsVertical'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1.5}
                                    stroke={'#02698C'}
                                  />
                                </div>
                              </Menu>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          {/* <div className="absolute bottom-20">
     
            <Pagination
              currentPage={currentPage2}
              totalPages={calculatePageCount(
                Number(categories?.data?.count) || 0
              )}
              onPageChange={handlePageChange2}
            />
          </div> */}
        </div>
      )}
      {/* modal */}
      <Modal
        customStyle={{ borderRadius: 16, width: '480px' }}
        isOpen={isOpen}
        onClose={handleCloseModal}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center px-4 py-2  flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon name={'IconList'} stroke="#02698C" height={52} width={52} />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <p className={'text-text2 text-lg font-bold leading-6'}>
              {isEditTRCategory
                ? 'Edit Safeguarding Category'
                : 'Create Safeguarding Category'}
            </p>
            <p className={'text-sm text-text1 font-normal leading-6'}>
              {isEditTRCategory
                ? 'Please edit your category title name'
                : 'Please give a name to your category title'}
            </p>
          </div>
          <div className="w-full mt-[10px]">
            <UITextInput
              label={'Title*'}
              onChange={(e) => {
                setCategoryName(e.target.value)
              }}
              onBlur={() => {}}
              placeholder="Please enter your category title"
              iconName={'none'}
              inputCustomClass="font-semibold"
              value={categoryName}
            />
          </div>
          <div className="w-full mt-[10px]">
            <UITextInput
              label={'Provider URL'}
              onChange={(e) => {
                setUrl(e.target.value)
              }}
              onBlur={() => {}}
              placeholder="Please insert Provider URL here"
              iconName={'none'}
              inputCustomClass="font-semibold"
              value={url}
            />
          </div>
          <div className="w-full p-4 bg-gray1 rounded-xl flex">
            <div className="flex-1">
              <p className="text-sm font-semibold leading-6 text-text4">
                Risk Assesment
              </p>
              {/* <p className="text-sm font-normal leading-6 text-text3">
                Can clients can access files in this sub category?
              </p> */}
            </div>
            <div>
              <UISwitch
                value={riskAssesmentSwitchValue}
                onValueChange={handleRiskSwitchChange}
              />
            </div>
          </div>
          <div className="w-full p-4 bg-gray1 rounded-xl flex">
            <div className="flex-1">
              <p className="text-sm font-semibold leading-6 text-text4">
                Expiry Date
              </p>
              {/* <p className="text-sm font-normal leading-6 text-text3">
                Can clients can access files in this sub category?
              </p> */}
            </div>
            <div>
              <UISwitch
                value={expiryDateSwitchValue}
                onValueChange={handleExpiryDateSwitchChange}
              />
            </div>
          </div>
          <div className="w-full p-4 bg-gray1 rounded-xl flex">
            <div className="flex-1">
              <p className="text-sm font-semibold leading-6 text-text4">
                Issue Date
              </p>
              {/* <p className="text-sm font-normal leading-6 text-text3">
                Can clients can access files in this sub category?
              </p> */}
            </div>
            <div>
              <UISwitch
                value={issueDateSwitchValue}
                onValueChange={handleIssueDateSwitchChange}
              />
            </div>
          </div>
          <div className="w-full mt-4">
            <UIButton
              disabled={categoryName == '' ? true : false}
              label={isEditTRCategory ? 'Update' : 'Create'}
              onClick={
                isEditTRCategory == true ? editCategory : createNewCategory
              }
            />
          </div>
        </div>
      </Modal>

      {/* edit modal */}

      {/* delete modal */}

      <Modal
        customStyle={{
          borderRadius: 16,
          padding: '20px 12px',
          width: '480px',
        }}
        isOpen={isOpenDeleteTRModalCategory}
        onClose={() =>
          setIsOpenDeleteTRModalCategory(!isOpenDeleteTRModalCategory)
        }
      >
        <div className={'max-h-[80vh] items-center p-4 flex flex-col gap-4'}>
          <div
            onClick={() =>
              setIsOpenDeleteTRModalCategory(!isOpenDeleteTRModalCategory)
            }
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={0.9}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center mb-5">
            <h1 className={'text-text2 text-lg font-bold leading-6'}>
              Delete Category
            </h1>
            <p className={'text-sm text-text1 font-normal leading-6'}>
              Are you sure you want to delete this Safeguarding category?
            </p>
          </div>

          <button
            onClick={removeCategory}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Yes, I am Sure
          </button>
          <button
            onClick={() =>
              setIsOpenDeleteTRModalCategory(!isOpenDeleteTRModalCategory)
            }
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default SafeguardingCategories
